import React from 'react';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
    partDisplay: {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '40px', // Minimum row height for readability
        padding: '4px 0',
        lineHeight: '1.2',
    },
    partNumberRow: {
        display: 'flex',
        alignItems: 'baseline',
        marginBottom: '2px',
    },
    partNumber: {
        fontWeight: 'bold',
        fontSize: '14px',
        color: '#333',
        marginRight: '4px',
    },
    revision: {
        fontSize: '14px',
        color: '#00acb5',
        fontWeight: 'bold',
    },
    description: {
        fontSize: '12px',
        color: '#555',
        lineHeight: '1.3',
        wordWrap: 'break-word',
        overflowWrap: 'break-word',
        hyphens: 'auto',
    },
    // For dropdown options
    dropdownOption: {
        display: 'flex',
        flexDirection: 'column',
        padding: '8px 12px',
        minHeight: '50px',
    },
    dropdownPartNumber: {
        fontWeight: 'bold',
        fontSize: '14px',
        color: '#333',
        marginBottom: '2px',
    },
    dropdownRevision: {
        fontSize: '14px',
        color: '#00acb5',
        fontWeight: 'bold',
        marginBottom: '4px',
    },
    dropdownDescription: {
        fontSize: '11px',
        color: '#555',
        lineHeight: '1.3',
        wordWrap: 'break-word',
        overflowWrap: 'break-word',
        hyphens: 'auto',
    },
    // For table cells
    tableCell: {
        padding: '0 !important',
        verticalAlign: 'top !important',
        textAlign: 'left',
    },
    // For side panels
    sidePanel: {
        padding: '6px 0',
        borderBottom: '1px solid #eee',
        '&:last-child': {
            borderBottom: 'none',
        },
    },
});

/**
 * Reusable component for displaying part information with improved layout
 * Shows part number and revision on one line, description below
 * Automatically wraps description text and adjusts row height
 */
const PartDisplay = ({ 
    part, 
    variant = 'default', // 'default', 'dropdown', 'table', 'sidePanel'
    showDescription = true,
    classes 
}) => {
    if (!part) return null;

    const { partId, revision, description } = part;
    
    // Determine which CSS classes to use based on variant
    const getContainerClass = () => {
        switch (variant) {
            case 'dropdown': return classes.dropdownOption;
            case 'table': return classes.tableCell;
            case 'sidePanel': return classes.sidePanel;
            default: return classes.partDisplay;
        }
    };

    const getPartNumberClass = () => {
        switch (variant) {
            case 'dropdown': return classes.dropdownPartNumber;
            default: return classes.partNumber;
        }
    };

    const getRevisionClass = () => {
        switch (variant) {
            case 'dropdown': return classes.dropdownRevision;
            default: return classes.revision;
        }
    };

    const getDescriptionClass = () => {
        switch (variant) {
            case 'dropdown': return classes.dropdownDescription;
            default: return classes.description;
        }
    };

    return (
        <div className={getContainerClass()}>
            <div className={classes.partNumberRow}>
                <span className={getPartNumberClass()}>{partId}</span>
                {revision && (
                    <>
                        <span className={getRevisionClass()}>rev</span>&nbsp;{revision}
                    </>
                )}
            </div>
            {showDescription && description && (
                <div className={getDescriptionClass()}>
                    {description}
                </div>
            )}
        </div>
    );
};

export default withStyles(styles)(PartDisplay);
